import React, { useState, useEffect, createRef } from "react";
import Header from "../components/Header";
import { useNavigate, useParams } from "react-router-dom";
import { useLocation } from "react-router";
import NFTDetailCard from "../components/base/NFTDetailCard";
import "../styles/base/Tab/NFTDetail.css";
import Tab from "../components/base/Tab";
import Button from "../components/base/Button";
import {MdArrowBack} from "react-icons/md";
import { getABCollection } from "../lib/artblocks";

const NFTDetail = () => {
  const [colors, setColors] = useState([]);
  const [item, setItem] = useState(null);
  const [isLoading, setIsLoading] = useState(true);
  const navigate = useNavigate();
  const { projectId } = useParams();
  const { state } = useLocation();

  const getColors = (colors) => {
    setColors((c) => [...c, ...colors]);
  };

  useEffect(() => {
    setColors([]);
    
    // If we have state from navigation, use it (this is the normal case)
    if (state?.item) {
      setItem(state.item);
      setIsLoading(false);
    } 
    // Otherwise, if we have projectId in URL, fetch it
    else if (projectId) {
      // Check if projectId is in the correct format (contractAddress-projectId)
      // If it contains a hyphen, it's likely the full composite ID
      const isCompositeId = projectId.includes('-');
      
      if (!isCompositeId) {
        // If it's just a number, we can't determine which contract it belongs to
        // Log a warning but still try to fetch (in case the API handles it)
        console.warn("Invalid project ID format. Expected format: contractAddress-projectId, got:", projectId);
      }

      (async () => {
        try {
          setIsLoading(true);
          const collection = await getABCollection(projectId);
          if (collection) {
            setItem(collection);
          } else {
            // If collection is null and projectId doesn't have hyphen, it's likely invalid format
            if (!isCompositeId) {
              console.error("Project not found. The project ID should be in format: contractAddress-projectId");
            } else {
              console.error("Project not found:", projectId);
            }
          }
        } catch (error) {
          console.error("Error loading project:", error);
        } finally {
          setIsLoading(false);
        }
      })();
    } else {
      setIsLoading(false);
    }
  }, [projectId, state]);

  if (isLoading) {
    return (
      <div>
        <Header />
        <div style={{paddingTop: "100px", paddingLeft: "20px", textAlign: "center"}}>
          <p>Loading project...</p>
        </div>
      </div>
    );
  }

  // Guard check: if no item, show error
  if (!item) {
    return (
      <div>
        <Header />
        <div style={{paddingTop: "100px", paddingLeft: "20px", textAlign: "center"}}>
          <p>Error: Missing collection information</p>
          <p style={{fontSize: "12px", color: "#666", marginTop: "10px"}}>
            Please navigate from a collection card or use a valid project URL.
          </p>
          <Button
            width="100px"
            height="40px"
            child={<div id="button-child">Go Back</div>}
            onClick={() => navigate(-1)}
            style={{marginTop: "20px"}}
          />
        </div>
      </div>
    );
  }

  return (
    <div>
      <Header />
      <div style={{paddingTop: "100px", paddingLeft: "20px", position: "relative"}}>
        <Button
          width="50px"
          height="50px"
          child={
            <div id="button-child">
              <MdArrowBack size="28px" />
            </div>
          }
          onClick={() => navigate(-1)}
          aria-label="Go back"
        />
      </div>
      <div className="nft-detail-card-wrapper">
        <NFTDetailCard
          width={"100%"}
          blurColor={colors[0]}
          child={
            //Detail Content
            <Tab item={item} getColors={getColors}></Tab>
          }
        />
      </div>
    </div>
  );
};

export default NFTDetail;
